import styled from '@emotion/styled';
import { Avatar as _Avatar, Typography } from '@material-ui/core';
import { Variant } from '@material-ui/core/styles/createTypography';
import AccountCircle from '@material-ui/icons/AccountCircle';
import { createElement, FC } from 'react';

import { SPACING_UNIT } from '../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../styleUtility/gridLayout';

type Props = {
  user: { name?: string; profileImageUrl?: string };
  size?: number;
  variant?: Variant;
  className?: string;
};

const AvatarAndName: FC<Props> = ({ user, size = 24, variant = 'body2', className }) => {
  const avatarStyle = {
    width: size,
    height: size,
  };

  return (
    <Root className={className}>
      {user.profileImageUrl ? (
        <Avatar src={user.profileImageUrl} alt={user.name} style={avatarStyle} />
      ) : (
        <AccountCircle style={avatarStyle} color="action" />
      )}
      <Name variant={variant} noWrap>
        {user.name}
      </Name>
    </Root>
  );
};

const Root = styled('div')`
  ${gridLayoutContainer({
    columns: ['auto', '1fr'],
    rows: ['auto'],
    areas: [['avatar', 'name']],
  })}
`;

const Avatar = styled(_Avatar)`
  ${gridLayoutItem('avatar')}
`;

const Name = styled(Typography)`
  ${gridLayoutItem('name', {
    alignSelf: 'center',
  })}
  margin-left: ${SPACING_UNIT}px;
`;

export default AvatarAndName;
